import React from "react";
import { useTranslation } from "react-i18next";
import { SharedEventList } from "./sharedEventList";

/**
 * HSE/KS Deviations List - Quality deviations only (ISO 9001:2015)
 */
export const HseKsDeviationsList = () => {
  const { t } = useTranslation();

  return (
    <SharedEventList
      activeTab="deviations"
      title="Avvik"
      subtitle="Oversikt over kvalitetsavvik (ISO 9001:2015 - kap. 10.2)"
      newButtonLabel={t("Nytt avvik")}
      newButtonPath="/dashboard/hse-ks/events/new?type=deviation"
      emptyMessage={t("Ingen avvik funnet")}
      searchPlaceholder={t("Søk i avvik...")}
      defaultFilters={{
        event_category: "law_violation,regulation_violation,procedure_violation",
      }}
    />
  );
};

